<script>
import ActivityList from "./components/ActivityList.vue";

export default {
  name: "TechInnoActivities",
  components: { ActivityList },
};
</script>

<template>
  <div class="tech-inno-activities">
    <ds-header title="科创活动管理"></ds-header>
    <activity-list />
  </div>
</template>

<style scoped lang="scss">
</style>
